var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.loadingVisible)?_c('app-loading'):_vm._e(),_c('router-view',{class:{blured:_vm.loadingVisible}}),_c('noty-container')],1)}
var staticRenderFns = []

export { render, staticRenderFns }